import { Banknote, Home } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";

function CostCard({ item, type }) {
  const Icon = type === "tuition" ? Banknote : Home;

  return (
    <article className="signature-card signature-card-interactive rounded-2xl p-5">
      <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-sky-glow text-royal-blue">
        <Icon className="h-5 w-5" aria-hidden="true" />
      </span>
      <p className="mt-4 text-xs font-semibold uppercase tracking-[0.14em] text-slate-text/65">{item.label}</p>
      <h3 className="mt-2 text-xl leading-tight text-midnight-navy sm:text-2xl md:text-3xl">{item.value}</h3>
      <p className="mt-3 text-sm leading-relaxed text-slate-text/80">{item.note}</p>
    </article>
  );
}

function CountryCostSection({ country }) {
  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Investment Snapshot"
          title="Tuition Fees and Cost of Living"
          description="Clear cost ranges to help students and families plan with confidence before shortlisting universities."
        />

        <div className="mt-10 grid gap-8 lg:grid-cols-2">
          <div>
            <h3 className="mb-4 text-2xl">Tuition Range</h3>
            <div className="grid gap-4">
              {country.cost.tuition.map((item) => (
                <CostCard key={item.label} item={item} type="tuition" />
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4 text-2xl">Living Range</h3>
            <div className="grid gap-4">
              {country.cost.living.map((item) => (
                <CostCard key={item.label} item={item} type="living" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default CountryCostSection;
